<template>
  <div class="gzhBox">
    <div>
      <img :src="ewm" alt="">
      <p class="color-9">请截图到微信内扫码</p>
    </div>
  </div>
</template>

<script>
import ewms from '@/images/eww.png'
export default {
  name: 'HomePage',
  components: {

  },
  data() {
    return {
      ewm: ewms,
    }
  },
  mounted() {

  },
  beforeUnmount() {

  },
  methods: {

  }
}
</script>

<style scoped>
.gzhBox {
  background-color: #dbdbdb;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
}
.gzhBox img{
  margin-top: 40px;
}
.gzhBox div {
  width: 300px;
  height: 300px;
  border-radius: 10px;
  background-color: #ffffff;
}
</style>